import { useOrganizationManager } from 'hooks/use-organization-manager/use-organization-manager';
import { useUrlManager } from 'hooks/use-url-manager/use-url-manager';
import { useUser } from 'hooks/use-user/use-user';
import { setAppLoaded } from 'store/app-status/app-status.slice';
import { useAppDispatch } from 'store/hooks';
import { debugLog } from 'utils/debug';
import { loginPendo } from 'utils/pendo';
import { hasAcceptedTos, requiresTosAcceptance } from 'utils/terms-of-service';

export const useAuthorizedAppInit = () => {
  const { initializeOrganization } = useOrganizationManager();
  const { goto } = useUrlManager();
  const dispatch = useAppDispatch();
  const { user } = useUser();

  const initApp = async () => {
    dispatch(setAppLoaded(false));

    let mustGoToPath = '';

    if (!user) {
      debugLog('/hooks/use-app-init/initApp() no user session found');
      return;
    }
    if (!user.preferences?.termsOfService && requiresTosAcceptance(user)) {
      if (!hasAcceptedTos(user)) {
        debugLog('/hooks/use-app-init/initApp() user will need to accept terms and conditions');
        mustGoToPath = '/setup-account/ex2';
      } else {
        debugLog('/hooks/use-app-init/initApp() user has accepted terms and conditions');
      }
    } else {
      debugLog('/hooks/use-app-init/initApp() user is excluded from terms and conditions check');
    }

    const organization = initializeOrganization();
    if (!organization?.organizationId) {
      debugLog('/hooks/use-app-init/initApp(): unable to determine organization id to establish context');
      return;
    }

    debugLog(`/hooks/use-app-init/initApp(): established organizationId context ${organization.organizationId}`);

    // Kick-off the trials store
    // TODO when GG-297 ready
    // await TRIAL.setOrganization(URL_MANAGER.readURL().organizationId || organizationId);

    loginPendo(organization, user);
    dispatch(setAppLoaded(true));

    if (mustGoToPath) {
      goto(mustGoToPath, { organizationId: organization.organizationId });
    }
  };

  return initApp;
};
